module.exports = __webpack_public_path__ + "img/50.5888e064.jpg";